import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  tr: {
    translation: {
      nav: {
        home: "Ana Sayfa",
        technology: "Teknoloji",
        hardware: "Donanım",
        solutions: "Çözümler",
        whyus: "Neden Biz?",
        contact: "İletişim",
      },
      footer: {
        tagline: "Akıllı su yönetimi ve kontrollü filizlendirme ile geleceğin fonksiyonel beslenmesi.",
        contact: "İletişim",
        nav: "Menü",
        rights: "Tüm hakları saklıdır.",
      },
      home: {
        overline: "Fonksiyonel Beslenme • Hidroponik Otomasyon",
        heroLines: [
          "Geleceğin Fonksiyonel",
          "Beslenmesi, Akıllı Su",
          "Yönetimiyle Başlıyor.",
        ],
        heroSub:
          "Sağlıklı beslenmenin kontrolünü elinize alın. Kurumsal ve ev tipi hidroponik otomasyonla kusursuz tohum filizlendirme.",
        btnCorporate: "Kurumsal Çözümler",
        btnIndividual: "Bireysel Kitler",
        mediaLabel: "Insert Machine Working Video/Image Here",
        howTitle: "Nasıl Çalışır?",
        howSub: "Tohumdan hasada, üç akıllı adımda tam kontrol.",
        cards: [
          {
            title: "Akıllı Su Yönetimi",
            desc: "ESP32 tabanlı sensörler pH, EC ve sterilite değerlerini gerçek zamanlı izler; su ve gübreyi hassasiyetle dengeler.",
          },
          {
            title: "Kontrollü Filizlenme",
            desc: "Çok katlı paslanmaz tepsilerde otomatik sulama ve püskürtme sistemiyle tohumlar ideal koşullarda filizlenir.",
          },
          {
            title: "Saf ve Besleyici Hasat",
            desc: "Isıl işlemsiz vakum kurutma ile maksimum biyoyararlanıma sahip, doğallığı bozulmamış ham madde elde edin.",
          },
        ],
      },
      tech: {
        overline: "Sistem Mimarisi",
        title: "Wate Logic & Hydroflow",
        sub: "ESP32 kontrol ünitesi, suyun her damlasını akıllıca yönetir. Sensörlerden gelen veriler anlık işlenir, vanalar ve dozaj pompaları otomatik ayarlanır.",
        diagramLabel: "Sistem Mimarisi Diyagramı",
        paramsTitle: "ESP32 ile İzlenen 5 Kritik Parametre",
        params: [
          { name: "pH Değeri", desc: "Besin çözeltisinin asit-baz dengesi sürekli ölçülür ve otomatik düzeltilir." },
          { name: "EC / İletkenlik", desc: "Çözeltideki besin yoğunluğu elektriksel iletkenlikle takip edilir." },
          { name: "Su Sertliği", desc: "Mineral konsantrasyonu izlenerek ideal su kalitesi korunur." },
          { name: "Sterilite", desc: "Patojen ve kirlilik kontrolüyle steril bir üretim ortamı sağlanır." },
          { name: "Bulanıklık (Turbidite)", desc: "Askıdaki parçacıklar ölçülerek suyun berraklığı garanti edilir." },
        ],
        highlight: "%95",
        highlightLabel: "Su ve Gübre Tasarrufu",
        highlightDesc: "Kapalı devre akıllı su yönetimiyle geleneksel tarıma kıyasla kaynak kullanımını minimuma indirir.",
      },
      hardware: {
        overline: "Ürün Ekosistemi",
        title: "Makine ve Donanım Ekosistemi",
        sub: "Kurumsal üretim tesislerinden ev tipi kitlere kadar, modüler ve ölçeklenebilir donanım ailesi.",
        products: [
          { name: "Growbot System 8i", desc: "5 kanal kontrol, gerçek zamanlı veri loglama. Endüstriyel ölçekli filizlendirme için tam otomasyon." },
          { name: "Multidoser", desc: "Anlık su parametreleri otomatik düzenleyici. Peristaltik pompalarla hassas besin dozajlama." },
          { name: "Vacuum Fog Dryer", desc: "Isıl işlemsiz kurutma, saf toz. Besin değerini koruyarak nem uzaklaştırma." },
          { name: "DIY Kitler", desc: "Hobi amaçlı tak-çalıştır modüler setler. Ev ortamında kolay kurulum ve kontrol." },
        ],
      },
      solutions: {
        overline: "Biyoteknoloji",
        title: "İleri Biyoteknolojik Çözümler",
        sub: "Tohumdan bitmiş ürüne, laboratuvar hassasiyetinde geliştirilmiş uçtan uca çözümler.",
        items: [
          { name: "Tohum Kaplama Teknolojisi", desc: "Tohumların çimlenme oranını ve dayanıklılığını artıran özel kaplama formülasyonları." },
          { name: "EMS Tabanlı Jel Üretimi", desc: "Kontrollü salınım sağlayan, besin taşıyıcı biyouyumlu jel matrisleri." },
          { name: "Phyto-Colostrum", desc: "Bitkisel kaynaklı, yüksek biyoyararlanımlı fonksiyonel besin bileşeni." },
          { name: "Saf Toz Öz Filiz Suyu", desc: "Vakum kurutma ile elde edilen, konsantre ve saf filiz özü tozu." },
        ],
        labLabel: "Laboratuvar Görseli",
      },
      whyus: {
        overline: "Manifesto",
        title: "Bu Kadar Uğraş Ne İçin?",
        chapters: [
          {
            no: "01",
            title: "Sağlığınız Sizin Hakkınız",
            text: "Sağlığınızdan ödün vermek bir yana, daha da sağlıklı beslenmek istiyorsanız; kendi smoothienizi, kendi ununuzu, kendi Phyto-Colostrum'unuzu ve çorbanızı tamamen kontrollü bir şekilde üretmek hakkınız.",
          },
          {
            no: "02",
            title: "Doğallığı Bozulmamış Ham Madde",
            text: "Doğallığı bozulmamış, maksimum biyoyararlanıma sahip ham madde garantisi sunuyoruz. Her adım, besinin özünü korumak için tasarlandı.",
          },
          {
            no: "03",
            title: "Tam Kontrol, Tam Şeffaflık",
            text: "Tohumdan hasada kadar üretim sürecinin tamamını izleyin ve yönetin. Ne yediğinizi bilmenin verdiği güven, en büyük lüks.",
          },
        ],
        finalLabel: "Doğa & Sağlık",
        finalQuote: "Doğallığı bozulmamış, maksimum biyoyararlanıma sahip ham madde garantisi.",
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        technology: "Technology",
        hardware: "Hardware",
        solutions: "Solutions",
        whyus: "Why Us?",
        contact: "Contact",
      },
      footer: {
        tagline: "The functional nutrition of the future, powered by smart water management and controlled sprouting.",
        contact: "Contact",
        nav: "Menu",
        rights: "All rights reserved.",
      },
      home: {
        overline: "Functional Nutrition • Hydroponic Automation",
        heroLines: [
          "The Functional Nutrition",
          "of the Future Begins with",
          "Smart Water Management.",
        ],
        heroSub:
          "Take control of healthy eating. Flawless seed sprouting through corporate and home-type hydroponic automation.",
        btnCorporate: "Corporate Solutions",
        btnIndividual: "Individual Kits",
        mediaLabel: "Insert Machine Working Video/Image Here",
        howTitle: "How It Works?",
        howSub: "From seed to harvest, full control in three smart steps.",
        cards: [
          {
            title: "Smart Water Management",
            desc: "ESP32-based sensors monitor pH, EC, and sterility in real time; precisely balancing water and nutrients.",
          },
          {
            title: "Controlled Sprouting",
            desc: "In multi-tier stainless trays, seeds sprout under ideal conditions with automated irrigation and misting.",
          },
          {
            title: "Pure & Nutritious Harvest",
            desc: "With heat-free vacuum drying, obtain raw material with maximum bioavailability and untouched naturalness.",
          },
        ],
      },
      tech: {
        overline: "System Architecture",
        title: "Wate Logic & Hydroflow",
        sub: "The ESP32 control unit intelligently manages every drop of water. Sensor data is processed instantly, valves and dosing pumps adjust automatically.",
        diagramLabel: "System Architecture Diagram",
        paramsTitle: "5 Critical Parameters Monitored by ESP32",
        params: [
          { name: "pH Value", desc: "The acid-base balance of the nutrient solution is continuously measured and auto-corrected." },
          { name: "EC / Conductivity", desc: "Nutrient concentration in the solution is tracked via electrical conductivity." },
          { name: "Water Hardness", desc: "Ideal water quality is maintained by monitoring mineral concentration." },
          { name: "Sterility", desc: "A sterile production environment is ensured through pathogen and contamination control." },
          { name: "Turbidity", desc: "Suspended particles are measured to guarantee water clarity." },
        ],
        highlight: "95%",
        highlightLabel: "Water & Fertilizer Savings",
        highlightDesc: "Closed-loop smart water management minimizes resource usage compared to traditional agriculture.",
      },
      hardware: {
        overline: "Product Ecosystem",
        title: "Machine & Hardware Ecosystem",
        sub: "From corporate production facilities to home kits, a modular and scalable hardware family.",
        products: [
          { name: "Growbot System 8i", desc: "5-channel control, real-time data logging. Full automation for industrial-scale sprouting." },
          { name: "Multidoser", desc: "Instant automatic water parameter regulator. Precise nutrient dosing with peristaltic pumps." },
          { name: "Vacuum Fog Dryer", desc: "Heat-free drying, pure powder. Moisture removal while preserving nutritional value." },
          { name: "DIY Kits", desc: "Plug-and-play modular sets for hobbyists. Easy setup and control at home." },
        ],
      },
      solutions: {
        overline: "Biotechnology",
        title: "Advanced Biotechnological Solutions",
        sub: "From seed to finished product, end-to-end solutions developed with laboratory precision.",
        items: [
          { name: "Seed Coating Technology", desc: "Special coating formulations that increase the germination rate and resilience of seeds." },
          { name: "EMS-Based Gel Production", desc: "Biocompatible gel matrices carrying nutrients with controlled release." },
          { name: "Phyto-Colostrum", desc: "A plant-based, highly bioavailable functional nutritional component." },
          { name: "Pure Powder Sprout Essence", desc: "Concentrated and pure sprout essence powder obtained through vacuum drying." },
        ],
        labLabel: "Laboratory Image",
      },
      whyus: {
        overline: "Manifesto",
        title: "What Is All This Effort For?",
        chapters: [
          {
            no: "01",
            title: "Your Health Is Your Right",
            text: "Far from compromising your health, if you want to eat even healthier; it is your right to produce your own smoothie, your own flour, your own Phyto-Colostrum, and your own soup in a fully controlled manner.",
          },
          {
            no: "02",
            title: "Untouched Raw Material",
            text: "We offer a guarantee of raw material with untouched naturalness and maximum bioavailability. Every step is designed to preserve the essence of the nutrient.",
          },
          {
            no: "03",
            title: "Full Control, Full Transparency",
            text: "Monitor and manage the entire production process from seed to harvest. The confidence of knowing what you eat is the greatest luxury.",
          },
        ],
        finalLabel: "Nature & Health",
        finalQuote: "A guarantee of raw material with untouched naturalness and maximum bioavailability.",
      },
    },
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        technology: "Technologie",
        hardware: "Hardware",
        solutions: "Lösungen",
        whyus: "Warum Wir?",
        contact: "Kontakt",
      },
      footer: {
        tagline: "Die funktionelle Ernährung der Zukunft, angetrieben durch intelligentes Wassermanagement und kontrolliertes Keimen.",
        contact: "Kontakt",
        nav: "Menü",
        rights: "Alle Rechte vorbehalten.",
      },
      home: {
        overline: "Funktionelle Ernährung • Hydroponik-Automatisierung",
        heroLines: [
          "Die funktionelle Ernährung",
          "der Zukunft beginnt mit",
          "intelligentem Wassermanagement.",
        ],
        heroSub:
          "Übernehmen Sie die Kontrolle über gesunde Ernährung. Perfekte Samenkeimung durch industrielle und häusliche Hydroponik-Automatisierung.",
        btnCorporate: "Unternehmenslösungen",
        btnIndividual: "Individuelle Kits",
        mediaLabel: "Insert Machine Working Video/Image Here",
        howTitle: "Wie funktioniert es?",
        howSub: "Vom Samen bis zur Ernte, volle Kontrolle in drei intelligenten Schritten.",
        cards: [
          {
            title: "Intelligentes Wassermanagement",
            desc: "ESP32-basierte Sensoren überwachen pH, EC und Sterilität in Echtzeit und balancieren Wasser und Nährstoffe präzise.",
          },
          {
            title: "Kontrolliertes Keimen",
            desc: "In mehrstöckigen Edelstahlschalen keimen Samen unter idealen Bedingungen mit automatisierter Bewässerung und Vernebelung.",
          },
          {
            title: "Reine & Nahrhafte Ernte",
            desc: "Durch hitzefreie Vakuumtrocknung erhalten Sie Rohstoffe mit maximaler Bioverfügbarkeit und unberührter Natürlichkeit.",
          },
        ],
      },
      tech: {
        overline: "Systemarchitektur",
        title: "Wate Logic & Hydroflow",
        sub: "Die ESP32-Steuereinheit verwaltet intelligent jeden Wassertropfen. Sensordaten werden sofort verarbeitet, Ventile und Dosierpumpen passen sich automatisch an.",
        diagramLabel: "Systemarchitektur-Diagramm",
        paramsTitle: "5 kritische Parameter, überwacht durch ESP32",
        params: [
          { name: "pH-Wert", desc: "Das Säure-Basen-Gleichgewicht der Nährlösung wird kontinuierlich gemessen und automatisch korrigiert." },
          { name: "EC / Leitfähigkeit", desc: "Die Nährstoffkonzentration wird über die elektrische Leitfähigkeit verfolgt." },
          { name: "Wasserhärte", desc: "Ideale Wasserqualität wird durch Überwachung der Mineralkonzentration aufrechterhalten." },
          { name: "Sterilität", desc: "Eine sterile Produktionsumgebung wird durch Pathogen- und Kontaminationskontrolle gewährleistet." },
          { name: "Trübung (Turbidität)", desc: "Schwebeteilchen werden gemessen, um die Klarheit des Wassers zu garantieren." },
        ],
        highlight: "95%",
        highlightLabel: "Wasser- & Düngerersparnis",
        highlightDesc: "Das geschlossene, intelligente Wassermanagement minimiert den Ressourcenverbrauch im Vergleich zur traditionellen Landwirtschaft.",
      },
      hardware: {
        overline: "Produkt-Ökosystem",
        title: "Maschinen- & Hardware-Ökosystem",
        sub: "Von industriellen Produktionsanlagen bis zu Heim-Kits, eine modulare und skalierbare Hardware-Familie.",
        products: [
          { name: "Growbot System 8i", desc: "5-Kanal-Steuerung, Echtzeit-Datenprotokollierung. Vollautomatisierung für industrielles Keimen." },
          { name: "Multidoser", desc: "Sofortiger automatischer Wasserparameter-Regler. Präzise Nährstoffdosierung mit Peristaltikpumpen." },
          { name: "Vacuum Fog Dryer", desc: "Hitzefreie Trocknung, reines Pulver. Feuchtigkeitsentfernung bei Erhalt des Nährwerts." },
          { name: "DIY-Kits", desc: "Plug-and-Play-Modulsets für Hobbyisten. Einfache Einrichtung und Steuerung zu Hause." },
        ],
      },
      solutions: {
        overline: "Biotechnologie",
        title: "Fortschrittliche biotechnologische Lösungen",
        sub: "Vom Samen bis zum fertigen Produkt, durchgängige Lösungen mit Laborpräzision entwickelt.",
        items: [
          { name: "Samenbeschichtungstechnologie", desc: "Spezielle Beschichtungsformulierungen, die die Keimrate und Widerstandsfähigkeit der Samen erhöhen." },
          { name: "EMS-basierte Gel-Produktion", desc: "Biokompatible Gel-Matrizen, die Nährstoffe mit kontrollierter Freisetzung transportieren." },
          { name: "Phyto-Colostrum", desc: "Ein pflanzlicher, hochbioverfügbarer funktioneller Nährstoffbestandteil." },
          { name: "Reines Keim-Essenz-Pulver", desc: "Konzentriertes und reines Keim-Essenz-Pulver, gewonnen durch Vakuumtrocknung." },
        ],
        labLabel: "Laborbild",
      },
      whyus: {
        overline: "Manifest",
        title: "Wofür ist all diese Mühe?",
        chapters: [
          {
            no: "01",
            title: "Ihre Gesundheit ist Ihr Recht",
            text: "Weit davon entfernt, Ihre Gesundheit zu gefährden, wenn Sie sich noch gesünder ernähren möchten; es ist Ihr Recht, Ihren eigenen Smoothie, Ihr eigenes Mehl, Ihr eigenes Phyto-Colostrum und Ihre eigene Suppe vollständig kontrolliert herzustellen.",
          },
          {
            no: "02",
            title: "Unberührter Rohstoff",
            text: "Wir bieten eine Garantie für Rohstoffe mit unberührter Natürlichkeit und maximaler Bioverfügbarkeit. Jeder Schritt wurde entwickelt, um die Essenz des Nährstoffs zu bewahren.",
          },
          {
            no: "03",
            title: "Volle Kontrolle, volle Transparenz",
            text: "Überwachen und verwalten Sie den gesamten Produktionsprozess vom Samen bis zur Ernte. Das Vertrauen zu wissen, was man isst, ist der größte Luxus.",
          },
        ],
        finalLabel: "Natur & Gesundheit",
        finalQuote: "Eine Garantie für Rohstoffe mit unberührter Natürlichkeit und maximaler Bioverfügbarkeit.",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "tr",
  fallbackLng: "tr",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
